import parse from 'html-react-parser';
import './style.sass';

import FullWrapper from '../full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

type NextProjectPropsType = {
    NextProject: {
        nextProjectImg: string;
        nextProjectTitle: string;
        product?: any;
        nextProjectLink: string;
        nextProjectLinkTitle: string;
        nextProjectText: string;
        nextProjectClassName?: string;
    };
};

const NextProject = ({
    NextProject: {
        nextProjectImg = '',
        nextProjectTitle,
        product,
        nextProjectLink = '#',
        nextProjectLinkTitle,
        nextProjectText,
        nextProjectClassName = '',
    },
}: NextProjectPropsType) => {
    return (
        <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className={`next-project ${nextProjectClassName}`} isMargin={false}>
                <div className="next-project__wrapper">
                    <a href={nextProjectLink} className="next-project__img">
                        {product && (
                            <div className="projects-block__product">
                                <img
                                    src="/images/svg/product.svg"
                                    alt="Собственный продукт"
                                    loading="lazy"
                                />
                            </div>
                        )}
                        <div
                            className="next-project__photo"
                            style={{ backgroundImage: `url(${nextProjectImg})` }}
                        />
                    </a>
                    <div className="next-project__info">
                        <div className="next-project__over-title">Следующий проект</div>
                        <a href={nextProjectLink} className="next-project__title">
                            {parse(nextProjectTitle)}
                        </a>
                        <div className="next-project__subtitle">{parse(nextProjectLinkTitle)}</div>
                        <div className="next-project__text">{parse(nextProjectText)}</div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default NextProject;
